import {
    NestedSelectableOptions,
    SelectableOptions,
} from 'commons/components/searchable-dropdown/searchable-dropdown.type';
import { TFunction } from 'core/i18n/i18n';
import { DeviceTypeDetails } from 'modules/devices/domain/api/device-type.api';
import {
    DeviceTypeTriggerCatalogue,
    TrackedTrigger,
} from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { toTrackedEventLabel } from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification-rows.mapper';
import { toTriggerOptionId } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/operator-trigger-id.business';
import {
    UNATTRIBUTED_TRIGGER_MARKER,
    OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGER_UNAVAILABLE_OPTION_KEY,
    OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGERS_GROUP_KEY,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.constants';

export const mapDeviceTypeOptions = (deviceTypes: DeviceTypeDetails[]): SelectableOptions[] =>
    deviceTypes.map((deviceType) => ({ id: deviceType.id, name: deviceType.name }));

const toTriggerOption = (deviceTypeId: string, trigger: TrackedTrigger, marker?: string): SelectableOptions => ({
    id: toTriggerOptionId(deviceTypeId, trigger.id),
    name: toTrackedEventLabel(trigger),
    marker,
});

const toRetiredTriggerOptions = (
    deviceTypeId: string,
    catalogueTriggerIds: Set<string>,
    storedTriggers: TrackedTrigger[],
    t: TFunction
): SelectableOptions[] =>
    storedTriggers
        .filter((trigger) => trigger.deviceTypeId === deviceTypeId && !catalogueTriggerIds.has(trigger.id))
        .map((trigger) => ({
            ...toTriggerOption(
                deviceTypeId,
                trigger,
                t(OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGER_UNAVAILABLE_OPTION_KEY)
            ),
            excludedFromSelectAll: true,
        }));

export const mapTriggerOptions = (
    catalogue: DeviceTypeTriggerCatalogue[],
    deviceTypes: DeviceTypeDetails[],
    t: TFunction,
    storedTriggers: TrackedTrigger[] = []
): NestedSelectableOptions[] =>
    catalogue.map(({ deviceTypeId, triggers }) => ({
        id: deviceTypeId,
        name: t(OPERATOR_CUSTOM_NOTIFICATION_FORM_TRIGGERS_GROUP_KEY, {
            deviceType: deviceTypes.find((deviceType) => deviceType.id === deviceTypeId)?.name ?? deviceTypeId,
        }),
        children: [
            ...triggers.map((trigger) =>
                toTriggerOption(
                    deviceTypeId,
                    trigger,
                    trigger.neverIdentifiedAnOperator ? UNATTRIBUTED_TRIGGER_MARKER : undefined
                )
            ),
            ...toRetiredTriggerOptions(deviceTypeId, new Set(triggers.map(({ id }) => id)), storedTriggers, t),
        ],
    }));
